const errors = {
  required: "Required",
  email: "Email is incorrect",
  invalidImage: "It does not look like a valid image"
};

export default errors;
